<template>

    <to-invoice></to-invoice>

</template>

<script>

import ToInvoice from "../../components/Business/ToInvoice";

export default {

    components: {
        ToInvoice,
    },

    metaInfo: {
        title:'To invoice',
    },

    name:'FinancialToinvoice',

}

</script>
